module.exports = __webpack_public_path__ + "static/img/1000000514_green.aedf52f4.jpg";